<template>
    <!-- <span>
        --{{disabled}}-- -->
	<v-text-field  
        :key="render"
        :label="titulo"
        :placeholder="placeholder"               
        v-model="value_data"
        :error="error"
        maxlength="10"
        v-mask="'##/##/####'"
        :disabled="disabled"
    >
    
        <template v-slot:prepend>
            <v-menu
                ref="dPicker"
                v-model="dPicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                   
                    >
                         mdi-calendar
                    </v-icon>
                </template>
               <v-date-picker
                @change="changePicker"
                v-model="date"                
                @input="dPicker = false"
            ></v-date-picker>
            </v-menu>						
        </template>
    
    
     
    </v-text-field>	  
    <!-- @change="changePicker" -->
    <!-- --{{date}}--<br> --{{value}}--{{render}} </span>  -->
    <!-- </span> -->
</template>
<script>
export default {   
    data(){
        return {            
            dPicker:false,
            // date:''
            date: new Date().toISOString().substr(0, 10),
            render:0
        }
    }, 
    props:{
        titulo:String,
        placeholder:String,
        value:String,
        error:Boolean,
        disabled:Boolean
    },
    computed:{
        value_data:{
            get: function() {
                // console.log('data', this.value);     
                       
                return this.value;
            },
            set: function(value) {
                // console.log('value', value)
                this.$emit('input', value)
            }
        },
        // date:{
        //     get: function() {
        //         if(this.value_data.length == 10){
        //             const [day,  month, year] = this.value_data.split('/');
        //             return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}` ;                         
        //         }else{
        //             return new Date().toISOString().substr(0, 10);
        //         }
        //     },
        //     set: function(v) {
        //         // console.log('value', value)
        //         // this.$emit('input', value)
        //          if (v){

        //             const [year, month, day] = v.split('-')
        //             this.value_data = day + "/" + month + "/" + year;
        //         }
        //     }
        // }
    },
    watch:{
        value(value_data){
            // console.log('vv',value_data)
            if(value_data.length == 10){
                const [day,  month, year] = value_data.split('/');
                this.date= `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}` ;                         
            }else{
                this.date= new Date().toISOString().substr(0, 10);
            }
        }
    },
    methods:{
        changePicker(v){
            // console.log(v);

             if (v){
                this.render++; 
                const [year, month, day] = v.split('-')
                this.value_data = day + "/" + month + "/" + year;
             }
        },
        // setDatePicker(){
        //     if(this.value_data.length == 10){
        //         const [day,  month, year] = this.value_data.split('/');
        //         this.date =  `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`                
        //     }
        // }


    }
    // directives:{
    //     'data-mask':{
    //         // hooks
    //         // bind(el,binding,vnode) principal
    //         // inserted(el,binding,vnode)
    //         // update(el,binding,vnode,oldVnode) esse as vezes
    //         // componentUpdated(el,binding,vnode, oldVnode)
    //         // unbind(el,binding,vnode)
    //         bind(el,binding,vnode){
    //             console.log('E', el)
    //             if(binding.value){
    //                 var f='';
    //                 var i = binding.value.length;
    //                 var saida = "#";
    //                 var texto = '##/##/####'.substring(i);
    //                 if (texto.substring(0,1) != saida){
    //                     f = texto.substring(0,1);
    //                 }

    //                 binding.value = binding.value + f;
    //             }
    //         }
    //     }
    // },
}
</script>